import React from 'react';
import Subscription from './Subscription';

export const ManageSubscription = () => {
    return <Subscription />;
};

export default ManageSubscription;
